import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material/material.module';
import { RouterModule } from '@angular/router';
import { AccountComponent } from './account.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { SignInComponent } from './components/sign-in/sign-in.component';

import { AccountRoutingModule } from './account-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StaticSourceDirective } from 'src/app/directives/static-src.directive';
import { OtpVerificationComponent } from './components/otp-verification/otp-verification.component';
import { UserManagementComponent } from '../settings/components/user-management/user-management.component';
import { TextPrettyPipe } from 'src/app/pipes/text-pretty.pipe';
import { AddUsersComponent } from '../settings/components/add-users/add-users.component';




@NgModule({
  declarations: [AccountComponent, SignUpComponent, SignInComponent, OtpVerificationComponent, UserManagementComponent, AddUsersComponent],
  imports: [
    MaterialModule,
    CommonModule,
    RouterModule,
    AccountRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    StaticSourceDirective,
    TextPrettyPipe
  ],
})
export class AccountModule {}
